module.exports = __webpack_public_path__ + "static/media/0222_IMG_LE_SOL_LEGNI_WALNUT.a0f23da3.png";